<script setup>
const props = defineProps({
  email: {
    type: String,
    default: undefined,
  },

  errors: {
    type: Object,
    default: () => ({}),
  },
});
const emit = defineEmits(['submit', 'resend']);

const { t } = useI18n();

const code = ref('');
const formRef = ref(null);
const containerRef = ref(null);

// Timer
let interval;
const time = ref(60);

onMounted(() => {
  interval = setInterval(() => {
    time.value = time.value > 0 ? time.value - 1 : 0;
  }, 1000);
});
onBeforeUnmount(() => {
  clearInterval(interval);
});
function resetTimer() {
  time.value = 30;
}

function handleResend(email) {
  emit('resend', email);
  resetTimer();
}

watch(
  () => props.errors,
  () => {
    if (!formRef.value) return;

    code.value = '';

    formRef.value.setErrors(props.errors);
    containerRef.value.focus();
  },
  { deep: true },
);
</script>

<template>
  <ModalBase class="modals-auth-code" :title="t('header.auth')">
    <div ref="containerRef" class="modals-auth-code__container" tabindex="-1">
      <div class="modals-auth-code__title">
        <span class="modals-auth-code__font modals-auth-code__font--title">
          {{ t('header.checkEmail') }}
        </span>
      </div>

      <VeeForm ref="formRef" class="modals-auth-code__form">
        <FormFieldCode
          v-model="code"
          class="modals-auth-code__input"
          placeholder="0"
          @complete="emit('submit', { email, code })"
        />
      </VeeForm>

      <UiButton
        v-if="time <= 0"
        class="modals-auth-code__button"
        type="button"
        theme="secondary"
        @click="handleResend(email)"
      >
        <span class="modals-auth-code__font modals-auth-code__font--button">
          {{ t('common.resend') }}
        </span>
      </UiButton>

      <div v-else class="modals-auth-code__timer">
        <span class="modals-auth-code__font modals-auth-code__font--timer">
          {{ t('header.resendTimer', { time }) }}
        </span>
      </div>
    </div>
  </ModalBase>
</template>

<style scoped lang="scss">
.modals-auth-code {
  &__font {
    display: block;

    &--title {
      font-size: em(18);
      font-weight: 400;
      line-height: math.div(24, 18);
    }

    &--button {
      font-size: em(20);
      font-weight: 500;
      line-height: math.div(22, 20);
    }

    &--timer {
      font-size: em(17);
      font-weight: 400;
      line-height: math.div(24, 17);
      text-align: center;
    }
  }

  &__container {
    display: flex;
    flex-direction: column;
    padding: em(35) em($modal-padding) em(37);

    @include media-breakpoint-down(sm) {
      padding-right: em($gap-sm);
      padding-left: em($gap-sm);
    }
  }

  &__title {
    text-align: center;
  }

  &__form {
    margin: 0 auto em(32);
  }

  &__button {
    width: em(309);
    height: em(51);
    margin: 0 auto;

    @include media-breakpoint-down(sm) {
      width: 100%;
    }
  }
}
</style>
